import { Typography, UnstyledButton } from '@capsule/consumer-design-system';

import styled from 'styled-components';

import { FormikTextField } from '../../Form/FormikTextField/FormikTextField';

export const MapContainerParent = styled.div<{ toggleShow: boolean; hasParentForm: boolean }>`
  margin-top: ${props => props.theme.space.s4};
  width: 100%;
  height: 50vh;

  ${props => props.theme.mediaQueries.mediumDown} {
    margin-left: calc(50% - 50vw);
    width: 100vw;
    height: ${props => (props.hasParentForm ? '50vh' : '66vh')};
  }
  ${props => (props.toggleShow ? 'display: block' : 'display: none;')}
`;

/*
 * In full screen mode:
 *   If this has a parent form (i.e.: it's not the transfer form view),
 *   pad max height less than what is required for the transfer form.
 */
export const ListContainer = styled.ul<{ toggleShow: boolean; isFullScreen: boolean; hasParentForm: boolean }>`
  width: 100%;
  margin-top: ${props => props.theme.space.s2};
  ${props => (props.toggleShow ? 'display: block;' : 'display: none;')}
  height: fit-content;
  ${props => props.theme.mediaQueries.mediumDown} {
    ${props =>
      props.isFullScreen
        ? props.hasParentForm
          ? 'max-height: calc(100vh - 230px)'
          : 'max-height: calc(100vh - 260px)'
        : 'max-height: calc(100vh - 440px)'}
  }
  ${props => props.theme.mediaQueries.medium} {
    max-height: calc(100vh - 260px);
  }
  overflow: auto;
  z-index: ${({ theme }) => theme.zIndex.z1};
`;

export const ListItem = styled.li<{ isSelected: boolean }>`
  background: none;
  font: inherit;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  color: ${props => (props.isSelected ? props.theme.colors.capsuleGreen60 : props.theme.colors.capsuleGray50)};
  padding: ${props => props.theme.space.s3} ${props => props.theme.space.none};
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.z3};
`;

export const ListTextContainer = styled.div`
  color: ${props => props.theme.colors.capsuleGreen60};
  text-align: left;
`;

export const ListText = styled.div`
  font-size: ${props => props.theme.fontSizes.body};
  margin-bottom: ${props => props.theme.space['0.3']};
  line-height: ${props => props.theme.lineHeights.body};
  color: ${props => props.theme.colors.capsuleGreen60};
`;

export const ListSubText = styled.div`
  margin-top: ${props => props.theme.space.s1};
  color: ${props => props.theme.colors.capsuleGray50};
`;

export const ListNumber = styled.div`
  font-size: ${props => props.theme.fontSizes.headerThree};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  margin-right: ${props => props.theme.space['3.0']};
  width: ${props => props.theme.space['2.0']};
  text-align: left;
`;

export const CheckIconContainer = styled.div`
  width: 3rem;
  height: 2rem;
  padding-left: ${props => props.theme.space['1.0']};
  margin-right: ${props => props.theme.space.none};
  margin-left: auto;
  fill: ${props => props.theme.colors.capsuleGreen60};
  flex: none;
`;

export const PlaceIconContainer = styled.div`
  width: 3rem;
  height: 3rem;
  padding-right: ${props => props.theme.space.s2};
  margin-right: ${props => props.theme.space.s2};
  fill: ${props => props.theme.colors.capsuleBlue90};
  flex: none;
`;

export const GoogleRecaptchaDisclaimerContainer = styled.div`
  color: ${props => props.theme.colors.capsuleGray10};
  display: flex;
  flex-direction: row;
  font-size: ${props => props.theme.fontSizes.small};
  margin-left: auto;
  align-items: center;
`;

export const GoogleRecaptchaIcon = styled.div`
  svg {
    fill: ${props => props.theme.colors.capsuleGray10};
    stroke: ${props => props.theme.colors.capsuleGray10};
    width: 2.4rem;
    height: 2.4rem;
  }
  margin-right: ${props => props.theme.space.s2};
`;

export const GoogleRecaptchaText = styled.div``;

export const FormikTextFieldWithTextareaStyles = styled(FormikTextField)`
  width: 100%;
  border-radius: ${({ theme }) => theme.radii.r100};
  padding: ${({ theme }) => theme.space.s4};
  box-sizing: border-box;
  display: flex;
  flex-grow: 1;

  &&& {
    border: 1px solid;

    border-color: ${({ theme }) => theme.colors.capsuleGreen60};
    color: ${({ theme }) => theme.colors.capsuleBlue50};
    outline-color: ${({ theme }) => theme.colors.capsuleGreen60};

    &::placeholder {
      color: ${({ theme }) => theme.colors.capsuleGray50};
    }

    &:focus {
      outline: solid 1px !important;
      outline-color: ${({ theme }) => theme.colors.capsuleGreen60} !important;
    }

    &[aria-invalid='true'] {
      border-color: ${({ theme }) => theme.colors.capsuleRed60};
      color: ${({ theme }) => theme.colors.capsuleRed60};
      outline-color: ${({ theme }) => theme.colors.capsuleRed60} !important;
    }
  }
`;

export const FauxLabel = styled(Typography)<{ isFocused: boolean; hasError: boolean }>`
  color: ${({ theme, hasError }) => (!hasError ? theme.colors.capsuleGreen60 : theme.colors.capsuleRed60)};
  display: ${({ isFocused }) => (isFocused ? 'none' : 'block')};
`;

export const TextFieldTransparentButton = styled(UnstyledButton)`
  position: absolute;
  width: ${({ theme }) => theme.space.s5};
  height: ${({ theme }) => theme.space.s5};
  background-color: ${({ theme }) => theme.colors.transparent};
  z-index: ${({ theme }) => theme.zIndex.z2};
`;
